import React from "react";

function OrangeCircleGage(props) {
  return (
   <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3359 16.3455C17.2687 14.0749 18.6161 9.04596 16.3454 5.11303C14.0748 1.1801 9.04588 -0.167492 5.1131 2.10309C1.18033 4.37368 -0.167066 9.40262 2.10361 13.3356C4.37428 17.2685 9.40317 18.6161 13.3359 16.3455Z" fill="#F37320" stroke="white" stroke-width="2"/>
  </svg>

  );
}
export default OrangeCircleGage;